export default __webpack_public_path__ + "static/poster-text-bg-af8d4e7bcf3e55b362c2e875eee2be68.svg";